import labels from "../../../helpers/labels.json";

export const sidebar_options = [
  {
    icon: require("../../../assets/images/my_cases.svg").default,
    inactive: require("../../../assets/images/my_cases.svg").default,
    title: labels.my_cases,
    path: "/view/cases",
    listItems: [
      {
        icon: require("../../../assets/images/mediation-active.svg").default,
        inactive: require("../../../assets/images/mediation-inactive.svg").default,
        title: labels.my_cases_mediation,
        path: "/view/cases?caseType=mediation",
      },
      {
        icon: require("../../../assets/images/mediation-active.svg").default,
        inactive: require("../../../assets/images/mediation-inactive.svg").default,
        title: labels.my_cases_arbitration,
        path: "/view/cases?caseType=arbitration",
      },
    ],
  },
  {
    icon: require("../../../assets/images/mis_dashboard_inactive.svg").default,
    inactive: require("../../../assets/images/mis_dashboard_inactive.svg").default,
    blueIcon: require("../../../assets/images/mis_dashboard_active.svg").default,
    title: labels.mis_dashboard,
    path: "/view/mis-dashboard",
  },
  // {
  //   icon: require("../../../assets/images/home.svg").default,
  //   inactive: require("../../../assets/images/homeInactive.svg").default,
  //   blueIcon: require("../../../assets/images/Home_active_Blue.svg").default,
  //   title: labels.generate_link,
  //   path: "/view/generate-public-link",
  // },
  // {
  //   icon: require("../../../assets/images/profileInactive.svg").default,
  //   inactive: require("../../../assets/images/profileInactive.svg").default,
  //   title: labels.order_dictation,
  //   path: "/mediator/order-dictation",
  // },
];
